import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseButton,
  XrkMessage,
  BaseSelect,
  BaseRadioGroup,
  BaseRadio,
  BaseDatePicker
} from 'xrk-components';
import { listPark, addProxyTax } from '../../data-source/apis';
import { DECLARE_METHOD } from '../../constants';
import appStore from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-djsj-add-dialog',
  props: {
    remove: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const { info } = storeToRefs(appStore.useUserStoreSetup);

const incomeMonth = ref([]);
const formData = ref({
  businessParkId: null,
  declareMethod: null, // 由园区赋值，不可修改
  incomeMonthStart: null,
  incomeMonthEnd: null
});

const formRules = {
  businessParkId: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ],
  declareMethod: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ],
  incomeMonthEnd: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ]
};

const yqRemoteMethod = async (name?: string) => {
  return listPark({ name, enable: 1, proxyId: info.value.finalDepId });
};

const onChangePark = (val, [option]) => {
  formData.value.declareMethod = option.declareMethod;
};
const onChangeMonth = val => {
  formData.value.incomeMonthStart = val?.[0] || '';
  formData.value.incomeMonthEnd = val?.[1] || '';
};
const onConfirm = async () => {
  await addProxyTax(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  props.remove?.();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "500px",
    title: "新增代缴税金",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref: "formRef",
            "label-position": "right",
            rules: formRules,
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "选择园区",
                prop: "businessParkId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    placeholder: "请选择",
                    clearable: "",
                    filterUseRemote: "",
                    valueKey: "id",
                    labelKey: "businessParkName",
                    remoteMethod: yqRemoteMethod,
                    modelValue: formData.value.businessParkId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.businessParkId) = $event)),
                    onChange: onChangePark
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "申报方式",
                prop: "declareMethod"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseRadioGroup), {
                    disabled: "",
                    modelValue: formData.value.declareMethod,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.declareMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DECLARE_METHOD), (item) => {
                        return (_openBlock(), _createBlock(_unref(BaseRadio), {
                          key: item.value,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "所属月份",
                prop: "incomeMonthEnd"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseDatePicker), {
                    type: "monthrange",
                    "range-separator": "至",
                    "value-format": "YYYY-MM",
                    "start-placeholder": '起',
                    "end-placeholder": '止',
                    modelValue: incomeMonth.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((incomeMonth).value = $event)),
                    onChange: onChangeMonth
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})